import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MarketingComponent } from './marketing.component';
import { SocialMediaPostingComponent } from './social-media-posting/social-media-posting.component';
import { EmailMarketingComponent } from './email-marketing/email-marketing.component';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { NbMenuItem } from '@nebular/theme';
import { CommonModule } from '@angular/common';

const marketingRoutes: Routes = [
  { path: '', component: MarketingComponent },
  { path: 'social-media-posting', component: SocialMediaPostingComponent },
  { path: 'media-analytics', component: EmailMarketingComponent },
  { path: 'email-marketing', component: EmailMarketingComponent }
];

const MENU_ITEMS:NbMenuItem[] = [
    {title:"Social Media",group:true},
    {
      title:"Calendar",
      icon:{icon:"list-outline",pack:'eva'},
      link:"/admin/marketing"
    },
    {
      title:"New Post",
      icon:{icon:"plus-outline",pack:'eva'},
      link:"/admin/marketing/social-media-posting"
    },

]

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(marketingRoutes),
    UbsViewContainersModule],
  exports: [RouterModule]
})
export class MarketingRoutingModule { 
  headerTitle:string = "Marketing Management";
  path:string = "marketing";
  menuTag:string = "marketingMenu"
  menuAndTitleOptions = {path:this.path,menuItems:MENU_ITEMS,headerTitle:this.headerTitle,menuTag:this.menuTag};
  
  constructor(private viewContainerService:ViewContainersService){
    console.log("UpdateMenuTitle",this.menuAndTitleOptions)
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(this.menuTag);
  }
}
